import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectPlayerName } from "../../selectors/selectPlayerInfo";
import { HOCHudComponent } from "../context-menu/HOCHudComponent";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
var _HudPlayerProfile = function (_a) {
    var name = _a.name;
    return (React.createElement("div", { className: "hud-icon-with-text hud-stat-background hud-stat-background-large" },
        React.createElement("div", { className: "hud-stat-text" },
            React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline }, name))));
};
export var HudPlayerProfile = connect(selectPlayerName)(HOCHudComponent(_HudPlayerProfile));



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/HudPlayerProfile.tsx
// module id = 2307
// module chunks = 3